import dynamic from "next/dynamic";

export const LazyVegaEmbed = dynamic(() => import("react-vega").then((m) => m.VegaEmbed), {
  ssr: false,
});
